module.exports = __webpack_public_path__ + "static/media/noun_think_2157497.ad0d2dc4.svg";